/**
 * 报价单与订舱委托的自动关联
 */
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import * as PriceConstant from '../parameters/PriceConstant'
import * as ChargeMeasure from '../parameters/ChargeMeasure'
import { Charge } from '@/class/model/act/Charge'
import $store from '@/store'
import { Message } from '@/utils/Message'
import * as RateUtil from './RateUtil'
import { ChargeUtils } from './ChargeUtils'
import { cache, cacheName } from '@/utils/cacheManager'

/**
 * OF
 */
export const DEFAULT_OF_CHARGE = 'OF'

/**
 * GP
 */
export const DEFAULT_EQTYPE_GP = 'GP'
/**
 * HC
 */
export const DEFAULT_EQTYPE_HC = 'HC'

export class PriceFcl2JobChargeUtil {
  constructor() {
  }

  //   public static const UNIT_MAP:Object=
  //     {	"20": ChargeMeasure.C20_CHARGE_MEASURE.code,
  //       "40":ChargeMeasure.C40_CHARGE_MEASURE.code,
  //       "HC":ChargeMeasure.C40H_CHARGE_MEASURE.code,
  //       "45":ChargeMeasure.C45_CHARGE_MEASURE.code
  //     }
  //
  //   public static const EQS:Array=["20","40","HC","45"];
  //

  //   /**
  //    * 运价等级 cost
  //    */
  //   private static const COST:int=0;
  //
  //   /**
  //    * 一级运价
  //    */
  //   private static const TIER_1:int=1;
  //
  //   /**
  //    * 二级运价
  //    */
  //   private static const TIER_2:int=2;
  //
  //   /**
  //    * 三级运价
  //    */
  //   private static const TIER_3:int=99;
  //
  //   /**
  //    * 应付
  //    */
  //   public static function convertPrice2CostCharge(job:Job,qf:QuotationFCLDetail,surchargeFcls:ArrayCollection,isAllIn:Boolean,isTEU:Boolean):ArrayCollection
  //   {
  //     var sameOffice:Boolean=qf.pf.branchId==job.opOffice;
  //     var targetField_pf:String= sameOffice? "cost" :"one";//同一分公司内，应付取运价成本，不同分公司之间应付取tier 1
  //     var targetField_sf:String= sameOffice? "cost" :"sum";//同一分公司内，应付取附加费成本，不同分公司之间应付取附加费卖价
  //
  //     var isReceivable:Boolean=false;//应付
  //     var typeMap:Object={"L":0,"D":1,"S":2};
  //     var eqMap:Object={};
  //     var seaEQs:ArrayCollection=job.seaEQ;
  //     var isOneContainerType:Boolean=seaEQs && seaEQs.length==1;//只有一种箱型
  //
  //     var field:String;
  //     for each(var seaEQ:SeaEQ in seaEQs){
  //     if(seaEQ.EQquantity<=0)
  //       continue;
  //     if(seaEQ.EQtype=="HC" && seaEQ.EQsize.replace("'","")=="40"){
  //       field="numHC";
  //     } else {
  //       field="num"+seaEQ.EQsize.replace("'","");
  //     }
  //     if(!eqMap.hasOwnProperty(field)){
  //       eqMap[field]={pf:[],sf:0};//主运费和附加费分别处理
  //     }
  //     (eqMap[field].pf as Array).push(seaEQ);
  //     eqMap[field].sf+=seaEQ.EQquantity;
  //   }
  //
  //     var charges:ArrayCollection=new ArrayCollection();
  //     var charge:Charge;
  //     var chargeItem:ChargeItem;
  //     var allIns:Object={"20":0,"40":0,"HC":0,"45":0};
  //     var eq:String;
  //     var rate:Number,exchange:Number;
  //
  //     var messages:Array=[];
  //     var sum:Number=0.0;
  //     for each(var sf:SurchargeFCL in surchargeFcls){
  //     if(sf.isGenerateCharge) {
  //       if(sf.casePrice!=PriceConstant.NIL){//按票收费
  //         chargeItem=ChargeItem.getChargeItemByScaleCode(sf.chargeScaleCode);
  //         if(chargeItem){
  //           charge = new Charge();
  //           charge.chargeItemId = chargeItem.itemId;
  //           charge.currency = sf.currency;
  //           charge.measure = sf.unit;
  //           charge.quantity = 1;
  //           charge.unitRate = sameOffice ? sf.costCasePrice : sf.casePrice;
  //           charge.taxRate= sameOffice ? sf.costVat : sf.sellVat;
  //           charge.taxAmount=charge.unitRate *charge.taxRate;
  //           charge.remarks=sf.remarks;
  //           copyDataToCharge(charge,job,isReceivable);
  //           charges.addItem(charge);
  //         } else {
  //           messages.push(sf.chargeScaleCode);
  //         }
  //       } else {
  //         sum=0.0;
  //         if(sf.chargeType=="S"){//附加费
  //           if(isTEU){
  //             for each(eq in EQS){
  //               if(eqMap.hasOwnProperty("num"+eq)){
  //                 rate=Number(sf[targetField_sf+eq]);
  //                 if(rate==PriceConstant.NIL || isNaN(rate))
  //                   continue;
  //                 if(isAllIn && sf.currency== "USD"){
  //                   allIns[eq]=allIns[eq]+rate;
  //                 } else {
  //                   charge=new Charge();
  //                   chargeItem=ChargeItem.getChargeItemByScaleCode(sf.chargeScaleCode);
  //                   if(chargeItem){
  //                     charge.chargeItemId = chargeItem.itemId;
  //                     charge.currency = sf.currency;
  //                     charge.unitRate = rate;
  //                     charge.measure=UNIT_MAP[eq] || sf.unit;
  //                     charge.quantity=eqMap["num"+eq].sf;
  //                     charge.taxRate= sameOffice ? sf.costVat : sf.sellVat;
  //                     charge.taxAmount=charge.unitRate *charge.taxRate;
  //                     charge.remarks=sf.remarks;
  //                     copyDataToCharge(charge,job,isReceivable);
  //                     charges.addItem(charge);
  //                   } else {
  //                     messages.push(sf.chargeScaleCode);
  //                   }
  //                 }
  //               }
  //             }
  //           } else {
  //             for each(eq in EQS){
  //               if(eqMap.hasOwnProperty("num"+eq)){
  //                 rate=Number(sf[targetField_sf+eq]);
  //                 if(rate==PriceConstant.NIL || isNaN(rate))
  //                   continue;
  //                 if(isAllIn && sf.currency== "USD"){
  //                   allIns[eq]=allIns[eq]+rate;
  //                 } else {
  //                   sum+= eqMap["num"+eq].sf*rate;
  //                 }
  //               }
  //             }
  //             if(sum){
  //               charge=new Charge();
  //               chargeItem=ChargeItem.getChargeItemByScaleCode(sf.chargeScaleCode);
  //               if(chargeItem){
  //                 charge.chargeItemId = chargeItem.itemId;
  //                 charge.currency = sf.currency;
  //                 if(isOneContainerType){
  //                   charge.quantity = seaEQs[0].EQquantity;
  //                   charge.unitRate = rate;
  //                 } else {
  //                   charge.quantity = 1;
  //                   charge.unitRate = sum;
  //                 }
  //                 charge.measure=ChargeMeasure.NML_CHARGE_MEASURE.code || sf.unit;
  //                 charge.taxRate= sameOffice ? sf.costVat : sf.sellVat;
  //                 charge.taxAmount=charge.unitRate *charge.taxRate;
  //                 charge.remarks=sf.remarks;
  //                 copyDataToCharge(charge,job,isReceivable);
  //                 charges.addItem(charge);
  //               } else {
  //                 messages.push(sf.chargeScaleCode);
  //               }
  //             }
  //           }
  //         } else if(sf.chargeType=="L" || sf.chargeType== "D"){
  //           if(isTEU){
  //             for each(eq in EQS){
  //               if(eqMap.hasOwnProperty("num"+eq)){
  //                 charge=new Charge();
  //                 chargeItem=ChargeItem.getChargeItemByScaleCode(sf.chargeScaleCode);
  //                 if(chargeItem){
  //                   rate=Number(sf[targetField_sf+eq]);
  //                   if(rate==PriceConstant.NIL || isNaN(rate))
  //                     continue;
  //                   charge.chargeItemId = chargeItem.itemId;
  //                   charge.currency = sf.currency;
  //                   charge.unitRate = rate;
  //                   charge.measure=UNIT_MAP[eq] || sf.unit;
  //                   charge.quantity = eqMap["num"+eq].sf;
  //                   charge.taxRate= sameOffice ? sf.costVat : sf.sellVat;
  //                   charge.taxAmount=charge.unitRate *charge.taxRate;
  //                   charge.remarks=sf.remarks;
  //                   copyDataToCharge(charge,job,isReceivable);
  //                   charges.addItem(charge);
  //                 } else {
  //                   messages.push(sf.chargeScaleCode);
  //                 }
  //               }
  //             }
  //           } else {
  //             for each(eq in EQS){
  //               if(eqMap.hasOwnProperty("num"+eq)){
  //                 rate=Number(sf[targetField_sf+eq]);
  //                 if(rate==PriceConstant.NIL || isNaN(rate))
  //                   continue;
  //                 sum+=eqMap["num"+eq].sf*rate;
  //               }
  //             }
  //             if(sum){
  //               charge=new Charge();
  //               chargeItem=ChargeItem.getChargeItemByScaleCode(sf.chargeScaleCode);
  //               if(chargeItem){
  //                 //									rate=Number(sf[targetField_sf+eq]);
  //                 //									if(rate==PriceConstant.NIL || isNaN(rate))
  //                 //										continue;
  //                 charge.chargeItemId = chargeItem.itemId;
  //                 charge.currency = sf.currency;
  //                 if(isOneContainerType){
  //                   charge.quantity = seaEQs[0].EQquantity;
  //                   charge.unitRate = rate;
  //                   charge.measure= sf.unit || ChargeMeasure.NML_CHARGE_MEASURE.code;
  //                 } else {
  //                   charge.quantity = 1;
  //                   charge.unitRate = sum;
  //                   charge.measure=ChargeMeasure.NML_CHARGE_MEASURE.code || sf.unit;
  //                 }
  //                 charge.taxRate= sameOffice ? sf.costVat : sf.sellVat;
  //                 charge.taxAmount=charge.unitRate *charge.taxRate;
  //                 charge.remarks=sf.remarks;
  //                 copyDataToCharge(charge,job,isReceivable);
  //                 charges.addItem(charge);
  //               } else {
  //                 messages.push(sf.chargeScaleCode);
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  //
  //     var isEQAllMatched:Boolean=true;//运价是否涵盖了JOB中的所有集装箱
  //     chargeItem=ChargeItem.getChargeItemByScaleCode('OF');
  //     if(chargeItem){
  //       var pf:PriceFcl=qf.pf;
  //       if(isAllIn){
  //         for each(eq in EQS){//计入AllIn
  //           if(eqMap.hasOwnProperty("num"+eq)){
  //             rate=Number(pf[targetField_pf+eq]);
  //             if(rate==PriceConstant.NIL || isNaN(rate))
  //               continue;
  //             pf[targetField_pf+eq+"AllIn"]=Math.ceil(rate+allIns[eq]);
  //           }
  //         }
  //       }
  //
  //       var priceFieldMap:Object={"0":"cost","1":"one","2":"two","99":"three"};
  //       if(isTEU){
  //         if(eqMap.hasOwnProperty("num45") && pf[targetField_pf+"45"]!=PriceConstant.NIL)  //num45
  //         {
  //           charge = new Charge();
  //           charge.chargeItemId = chargeItem.itemId; //海运费
  //           charge.currency = pf.currency;
  //           charge.measure = ChargeMeasure.C45_CHARGE_MEASURE.code; // 单位
  //           charge.quantity=0;
  //           for each(seaEQ in eqMap.num45.pf){
  //             if(seaEQ.EQtype==qf.eqType){
  //               charge.quantity += seaEQ.EQquantity; //数量
  //             } else {
  //               isEQAllMatched=false;
  //             }
  //           }
  // //						charge.quantity = eqMap.num45; //数量
  //           charge.unitRate = Math.ceil(Number(pf[targetField_pf+"45AllIn"]));
  //           charge.taxRate= sameOffice ? pf.costVat : pf.sellVat;
  //           charge.taxAmount=charge.unitRate *charge.taxRate;
  //           copyDataToCharge(charge,job,isReceivable);
  //           charges.addItemAt(charge,0);
  //         }
  //         if(eqMap.hasOwnProperty("numHC") && pf[targetField_pf+"HC"]!=PriceConstant.NIL)  //40HC
  //         {
  //           charge = new Charge();
  //           charge.chargeItemId = chargeItem.itemId; //海运费
  //           charge.currency = pf.currency;
  //           charge.measure = ChargeMeasure.C40H_CHARGE_MEASURE.code; // 单位
  //           charge.quantity=0;
  //           for each(seaEQ in eqMap.numHC.pf){
  //             if(seaEQ.EQtype==qf.eqType){
  //               charge.quantity += seaEQ.EQquantity; //数量
  //             } else {
  //               isEQAllMatched=false;
  //             }
  //           }
  // //						charge.quantity = eqMap.numHC; //数量
  //           charge.unitRate = Math.ceil(Number(qf.pf[targetField_pf+"HCAllIn"]));
  //           charge.taxRate= sameOffice ? pf.costVat : pf.sellVat;
  //           charge.taxAmount=charge.unitRate *charge.taxRate;
  //           copyDataToCharge(charge,job,isReceivable);
  //           charges.addItemAt(charge,0);
  //         }
  //         if(eqMap.hasOwnProperty("num40")  && pf[targetField_pf+"40"]!=PriceConstant.NIL)  //num40
  //         {
  //           charge = new Charge();
  //           charge.chargeItemId = chargeItem.itemId; //海运费
  //           charge.currency = pf.currency;
  //           charge.measure = ChargeMeasure.C40_CHARGE_MEASURE.code; //"C40"; //单位
  //           charge.quantity=0;
  //           for each(seaEQ in eqMap.num40.pf){
  //             if(seaEQ.EQtype==qf.eqType){
  //               charge.quantity += seaEQ.EQquantity; //数量
  //             } else {
  //               isEQAllMatched=false;
  //             }
  //           }
  // //						charge.quantity = eqMap.num40; //数量
  //           charge.unitRate = Math.ceil(Number(qf.pf[targetField_pf+"40AllIn"]));
  //           charge.taxRate= sameOffice ? pf.costVat : pf.sellVat;
  //           charge.taxAmount=charge.unitRate *charge.taxRate;
  //           copyDataToCharge(charge,job,isReceivable);
  //           charges.addItemAt(charge,0);
  //         }
  //         if(eqMap.hasOwnProperty("num20") && pf[targetField_pf+"20"]!=PriceConstant.NIL)  //num20
  //         {
  //           charge = new Charge();
  //           charge.chargeItemId = chargeItem.itemId;//32; //海运费
  //           charge.currency = pf.currency;
  //           charge.measure = ChargeMeasure.C20_CHARGE_MEASURE.code; //"C20"; //单位
  //           charge.quantity=0;
  //           for each(seaEQ in eqMap.num20.pf){
  //             if(seaEQ.EQtype==qf.eqType){
  //               charge.quantity += seaEQ.EQquantity; //数量
  //             } else {
  //               isEQAllMatched=false;
  //             }
  //           }
  // //						charge.quantity = eqMap.num20; //数量
  //           charge.unitRate = Math.ceil(Number(pf[targetField_pf+"20AllIn"]));
  //           charge.taxRate= sameOffice ? pf.costVat : pf.sellVat;
  //           charge.taxAmount=charge.unitRate *charge.taxRate;
  //           copyDataToCharge(charge,job,isReceivable);
  //           charges.addItemAt(charge,0);
  //         }
  //       } else {
  //         sum=0.0;
  //         if(eqMap.hasOwnProperty("num45") && pf[targetField_pf+"45"]!=PriceConstant.NIL)  //num45
  //         {
  //           rate=Math.ceil(Number(pf[targetField_pf+"45AllIn"]));
  //           for each(seaEQ in eqMap.num45.pf){
  //             if(seaEQ.EQtype==qf.eqType){
  //               sum+= seaEQ.EQquantity*rate;
  //             } else {
  //               isEQAllMatched=false;
  //             }
  //           }
  // //						sum+= eqMap.num45*rate;
  //         }
  //         if(eqMap.hasOwnProperty("numHC") && pf[targetField_pf+"HC"]!=PriceConstant.NIL)  //40HC
  //         {
  //           rate=Math.ceil(Number(pf[targetField_pf+"HCAllIn"]));
  //           for each(seaEQ in eqMap.numHC.pf){
  //             if(seaEQ.EQtype==qf.eqType){
  //               sum+= seaEQ.EQquantity*rate;
  //             } else {
  //               isEQAllMatched=false;
  //             }
  //           }
  // //						sum+= eqMap.numHC*rate;
  //         }
  //         if(eqMap.hasOwnProperty("num40")  && pf[targetField_pf+"40"]!=PriceConstant.NIL)  //num40
  //         {
  //           rate=Math.ceil(Number(pf[targetField_pf+"40AllIn"]));
  //           for each(seaEQ in eqMap.num40.pf){
  //             if(seaEQ.EQtype==qf.eqType){
  //               sum+= seaEQ.EQquantity*rate;
  //             } else {
  //               isEQAllMatched=false;
  //             }
  //           }
  // //						sum+= eqMap.num40*rate;
  //         }
  //         if(eqMap.hasOwnProperty("num20") && pf[targetField_pf+"20"]!=PriceConstant.NIL)  //num20
  //         {
  //           rate=Math.ceil(Number(pf[targetField_pf+"20AllIn"]));
  //           for each(seaEQ in eqMap.num20.pf){
  //             if(seaEQ.EQtype==qf.eqType){
  //               sum+= seaEQ.EQquantity*rate;
  //             } else {
  //               isEQAllMatched=false;
  //             }
  //           }
  // //						sum+= eqMap.num20*rate;
  //         }
  //         if(sum){
  //           charge = new Charge();
  //           charge.chargeItemId = chargeItem.itemId;//32; //海运费
  //           charge.currency = pf.currency;
  //           charge.measure = ChargeMeasure.NML_CHARGE_MEASURE.code;
  //           if(isOneContainerType){
  //             charge.quantity = seaEQs[0].EQquantity;
  //             charge.unitRate = rate;
  //           } else {
  //             charge.quantity = 1;
  //             charge.unitRate = sum;
  //           }
  //           charge.taxRate= sameOffice ? pf.costVat : pf.sellVat;
  //           charge.taxAmount=charge.unitRate *charge.taxRate;
  //           copyDataToCharge(charge,job,isReceivable);
  //           charges.addItemAt(charge,0);
  //         }
  //       }
  //     } else {
  //       messages.push("OF");
  //     }
  //
  //     if(!isEQAllMatched){
  //       if(messages.length>0){
  //         messages=["费用"+messages.join()+"未找到！"];
  //       }
  //       messages.push("部分集装箱没有对应箱型的海运费，请手动添加！");
  //       MessageDialog.warning(messages.join());
  //     } else {
  //       if(messages.length>0){
  //         MessageDialog.warning("费用"+messages.join()+"未找到！");
  //       }
  //     }
  //     return charges;
  //   }
  //
  //   public static function convertPrice2SellCharge(job:Job,qf:QuotationFCLDetail,surchargeFcls:ArrayCollection,isAllIn:Boolean,isTEU:Boolean):ArrayCollection
  //   {
  //     if(qf.pf.branchId!=job.opOffice)
  //       return new ArrayCollection();
  //
  //     var isReceivable:Boolean=true;//应收
  //     var eqs:Array=["20","40","HC","45"];
  //     var typeMap:Object={"L":0,"D":1,"S":2};
  //     var eqMap:Object={};
  //     var seaEQs:ArrayCollection=job.seaEQ;
  //     var isOneContainerType:Boolean=seaEQs && seaEQs.length==1;//只有一种箱型
  //
  //     var field:String;
  //     for each(var seaEQ:SeaEQ in seaEQs){
  //     if(seaEQ.EQquantity<=0)
  //       continue;
  //     if(seaEQ.EQtype=="HC" && seaEQ.EQsize.replace("'","")=="40"){
  //       field="numHC";
  //     } else {
  //       field="num"+seaEQ.EQsize.replace("'","");
  //     }
  //     if(!eqMap.hasOwnProperty(field)){
  //       eqMap[field]={pf:[],sf:0};//主运费和附加费分别处理
  //     }
  //     (eqMap[field].pf as Array).push(seaEQ);
  //     eqMap[field].sf+=seaEQ.EQquantity;
  //   }
  //
  //     var charges:ArrayCollection=new ArrayCollection();
  //     var charge:Charge;
  //     var chargeItem:ChargeItem;
  //     var allIns:Object={"20":0,"40":0,"HC":0,"45":0};
  //
  //     var eq:String;
  //     var rate:Number,exchange:Number;
  //
  //     var sum:Number=0.0;
  //     var messages:Array=[];
  //     for each(var sf:SurchargeFCL in surchargeFcls){
  //     if(sf.isGenerateCharge) {
  //       if(sf.casePrice!=PriceConstant.NIL){
  //         chargeItem=ChargeItem.getChargeItemByScaleCode(sf.chargeScaleCode);
  //         if(chargeItem){
  //           //应收
  //           charge=new Charge();
  //           charge = new Charge();
  //           charge.chargeItemId = chargeItem.itemId;
  //           charge.currency = sf.currency;
  //           charge.measure = sf.unit;
  //           charge.quantity = 1;
  //           charge.unitRate = sf.casePrice;
  //           charge.taxRate= sf.sellVat;
  //           charge.taxAmount=charge.unitRate *charge.taxRate;
  //           charge.remarks=sf.remarks;
  //           copyDataToCharge(charge,job,isReceivable);
  //           charges.addItem(charge);
  //         } else {
  //           messages.push(sf.chargeScaleCode);
  //         }
  //       } else {
  //         sum=0.0;
  //         if(sf.chargeType=="S"){
  //           if(isTEU){
  //             for each(eq in EQS){
  //               if(eqMap.hasOwnProperty("num"+eq)){
  //                 rate=Number(sf["sum"+eq]);
  //                 if(rate==PriceConstant.NIL || isNaN(rate))
  //                   continue;
  //                 if(isAllIn && sf.currency== "USD"){
  //                   allIns[eq]=allIns[eq]+rate;
  //                 }
  //                 chargeItem=ChargeItem.getChargeItemByScaleCode(sf.chargeScaleCode);
  //                 if(chargeItem){
  //                   charge=new Charge();
  //                   charge.chargeItemId = chargeItem.itemId;
  //                   charge.currency = sf.currency;
  //                   charge.unitRate = rate;
  //                   charge.measure=ChargeMeasure.NML_CHARGE_MEASURE.code || sf.unit;
  //                   charge.quantity = eqMap["num"+eq].sf;
  //                   charge.taxRate=sf.sellVat;
  //                   charge.taxAmount=charge.unitRate *charge.taxRate;
  //                   charge.remarks=sf.remarks;
  //                   copyDataToCharge(charge,job,isReceivable);
  //                   charges.addItem(charge);
  //                 } else {
  //                   messages.push(sf.chargeScaleCode);
  //                 }
  //               }
  //             }
  //           } else {
  //             for each(eq in EQS){
  //               if(eqMap.hasOwnProperty("num"+eq)){
  //                 rate=Number(sf["sum"+eq]);
  //                 if(rate==PriceConstant.NIL || isNaN(rate))
  //                   continue;
  //                 if(isAllIn && sf.currency== "USD"){
  //                   allIns[eq] = allIns[eq]+rate;
  //                 }
  //                 sum += eqMap["num"+eq].sf*rate;
  //               }
  //             }
  //             if(sum){
  //               chargeItem=ChargeItem.getChargeItemByScaleCode(sf.chargeScaleCode);
  //               if(chargeItem){
  //                 charge=new Charge();
  //                 charge.chargeItemId = chargeItem.itemId;
  //                 charge.currency = sf.currency;
  //                 if(isOneContainerType){
  //                   charge.quantity = seaEQs[0].EQquantity;
  //                   charge.unitRate = rate;
  //                 } else {
  //                   charge.quantity = 1;
  //                   charge.unitRate = sum;
  //                 }
  //                 charge.measure=ChargeMeasure.NML_CHARGE_MEASURE.code || sf.unit;
  //                 charge.taxRate=sf.sellVat;
  //                 charge.taxAmount=charge.unitRate *charge.taxRate;
  //                 charge.remarks=sf.remarks;
  //                 copyDataToCharge(charge,job,isReceivable);
  //                 charges.addItem(charge);
  //               } else {
  //                 messages.push(sf.chargeScaleCode);
  //               }
  //             }
  //           }
  //         } else if(sf.chargeType=="L" || sf.chargeType== "D"){
  //           if(isTEU){
  //             for each(eq in eqs){
  //               //应收
  //               if(eqMap.hasOwnProperty("num"+eq)){
  //                 chargeItem=ChargeItem.getChargeItemByScaleCode(sf.chargeScaleCode);
  //                 if(chargeItem){
  //                   rate=Number(sf["sum"+eq]);
  //                   if(rate==PriceConstant.NIL || isNaN(rate))
  //                     continue;
  //                   charge=new Charge();
  //                   charge.chargeItemId = chargeItem.itemId;
  //                   charge.currency = sf.currency;
  //                   charge.unitRate = rate;
  //                   charge.measure=UNIT_MAP[eq] || sf.unit;
  //                   charge.quantity = eqMap["num"+eq].sf;
  //                   charge.taxRate=sf.sellVat;
  //                   charge.taxAmount=charge.unitRate *charge.taxRate;
  //                   charge.remarks=sf.remarks;
  //                   copyDataToCharge(charge,job,isReceivable);
  //                   charges.addItem(charge);
  //                 } else {
  //                   messages.push(sf.chargeScaleCode);
  //                 }
  //               }
  //             }
  //           } else {
  //             for each(eq in eqs){
  //               //应收
  //               if(eqMap.hasOwnProperty("num"+eq)){
  //                 rate=Number(sf["sum"+eq]);
  //                 if(rate==PriceConstant.NIL || isNaN(rate))
  //                   continue;
  //                 sum+=eqMap["num"+eq].sf*rate;
  //               }
  //             }
  //             if(sum){
  //               chargeItem=ChargeItem.getChargeItemByScaleCode(sf.chargeScaleCode);
  //               if(chargeItem){
  //                 charge=new Charge();
  //                 charge.chargeItemId = chargeItem.itemId;
  //                 charge.currency = sf.currency;
  //                 if(isOneContainerType){
  //                   charge.quantity = seaEQs[0].EQquantity;
  //                   charge.unitRate = rate;
  //                   charge.measure=sf.unit || ChargeMeasure.NML_CHARGE_MEASURE.code;
  //                 } else {
  //                   charge.quantity = 1;
  //                   charge.unitRate = sum;
  //                   charge.measure=ChargeMeasure.NML_CHARGE_MEASURE.code || sf.unit;
  //                 }
  //                 charge.taxRate=sf.sellVat;
  //                 charge.taxAmount=charge.unitRate *charge.taxRate;
  //                 charge.remarks=sf.remarks;
  //                 copyDataToCharge(charge,job,isReceivable);
  //                 charges.addItem(charge);
  //               } else {
  //                 messages.push(sf.chargeScaleCode);
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  //
  //     var isEQAllMatched:Boolean=true;//运价是否涵盖了JOB中的所有集装箱
  //     chargeItem=ChargeItem.getChargeItemByScaleCode('OF');
  //     if(chargeItem){
  //       if(isAllIn){
  //         for each(eq in EQS){//计入AllIn
  //           if(eqMap.hasOwnProperty("num"+eq)){
  //             if(qf["eq"+eq]=="")
  //               continue;
  //             rate=Number(qf["eq"+eq]);
  //             if(rate==PriceConstant.NIL || isNaN(rate))
  //               continue;
  //             qf["eq"+eq]=Math.ceil(rate+allIns[eq]);
  //           }
  //         }
  //       }
  //
  //       var priceFieldMap:Object={"0":"cost","1":"one","2":"two","99":"three"};
  //       if(isTEU){
  //         if(eqMap.hasOwnProperty("num45"))  //num45
  //         {
  //           if(qf.eq45){
  //             charge = new Charge();
  //             charge.chargeItemId = chargeItem.itemId; //海运费
  //             charge.currency = qf.currency;
  //             charge.measure = ChargeMeasure.C45_CHARGE_MEASURE.code; // 单位
  //             charge.quantity=0;
  //             for each(seaEQ in eqMap.num45.pf){
  //               if(seaEQ.EQtype==qf.eqType){
  //                 charge.quantity += seaEQ.EQquantity; //数量
  //               } else {
  //                 isEQAllMatched=false;
  //               }
  //             }
  // //							charge.quantity = eqMap.num45; //数量
  //             charge.unitRate = Math.ceil(Number(qf.eq45));
  //             charge.taxRate=qf.pf.sellVat;
  //             charge.taxAmount=charge.unitRate *charge.taxRate;
  //             copyDataToCharge(charge,job,isReceivable);
  //             charges.addItemAt(charge,0);
  //           }
  //         }
  //         if(eqMap.hasOwnProperty("numHC"))  //40HC
  //         {
  //           if(qf.eqHC){
  //             charge = new Charge();
  //             charge.chargeItemId = chargeItem.itemId; //海运费
  //             charge.currency = qf.currency;
  //             charge.measure = ChargeMeasure.C40H_CHARGE_MEASURE.code; // 单位
  //             charge.quantity=0;
  //             for each(seaEQ in eqMap.numHC.pf){
  //               if(seaEQ.EQtype==qf.eqType){
  //                 charge.quantity += seaEQ.EQquantity; //数量
  //               } else {
  //                 isEQAllMatched=false;
  //               }
  //             }
  // //							charge.quantity = eqMap.numHC; //数量
  //             charge.unitRate = Math.ceil(Number(qf.eqHC));
  //             charge.taxRate=qf.pf.sellVat;
  //             charge.taxAmount=charge.unitRate *charge.taxRate;
  //             copyDataToCharge(charge,job,isReceivable);
  //             charges.addItemAt(charge,0);
  //           }
  //         }
  //         if(eqMap.hasOwnProperty("num40"))  //num40
  //         {
  //           if(qf.eq40){
  //             charge = new Charge();
  //             charge.chargeItemId = chargeItem.itemId; //海运费
  //             charge.currency = qf.currency;
  //             charge.measure = ChargeMeasure.C40_CHARGE_MEASURE.code; //"C40"; //单位
  //             charge.quantity=0;
  //             for each(seaEQ in eqMap.num40.pf){
  //               if(seaEQ.EQtype==qf.eqType){
  //                 charge.quantity += seaEQ.EQquantity; //数量
  //               } else {
  //                 isEQAllMatched=false;
  //               }
  //             }
  // //							charge.quantity = eqMap.num40; //数量
  //             charge.unitRate = Math.ceil(Number(qf.eq40));
  //             charge.taxRate=qf.pf.sellVat;
  //             charge.taxAmount=charge.unitRate *charge.taxRate;
  //             copyDataToCharge(charge,job,isReceivable);
  //             charges.addItemAt(charge,0);
  //           }
  //         }
  //         if(eqMap.hasOwnProperty("num20"))  //num20
  //         {
  //           if(qf.eq20){
  //             charge = new Charge();
  //             charge.chargeItemId = chargeItem.itemId;//32; //海运费
  //             charge.currency = qf.currency;
  //             charge.measure = ChargeMeasure.C20_CHARGE_MEASURE.code; //"C20"; //单位
  //             charge.quantity=0;
  //             for each(seaEQ in eqMap.num20.pf){
  //               if(seaEQ.EQtype==qf.eqType){
  //                 charge.quantity += seaEQ.EQquantity; //数量
  //               } else {
  //                 isEQAllMatched=false;
  //               }
  //             }
  // //							charge.quantity = eqMap.num20; //数量
  //             charge.unitRate = Math.ceil(Number(qf.eq20));
  //             charge.taxRate=qf.pf.sellVat;
  //             charge.taxAmount=charge.unitRate *charge.taxRate;
  //             copyDataToCharge(charge,job,isReceivable);
  //             charges.addItemAt(charge,0);
  //           }
  //         }
  //       } else {//合并各箱型
  //         sum=0.0;
  //         if(eqMap.hasOwnProperty("num45"))  //num45
  //         {
  //           if(qf.eq45){
  //             rate=Math.ceil(Number(qf.eq45));
  //             for each(seaEQ in eqMap.num45.pf){
  //               if(seaEQ.EQtype==qf.eqType){
  //                 sum+= seaEQ.EQquantity*rate;
  //               } else {
  //                 isEQAllMatched=false;
  //               }
  //             }
  // //							sum+=eqMap.num45 * rate;
  //           }
  //         }
  //         if(eqMap.hasOwnProperty("numHC"))  //40HC
  //         {
  //           if(qf.eqHC){
  //             rate=Math.ceil(Number(qf.eqHC));
  //             for each(seaEQ in eqMap.numHC.pf){
  //               if(seaEQ.EQtype==qf.eqType){
  //                 sum+= seaEQ.EQquantity*rate;
  //               } else {
  //                 isEQAllMatched=false;
  //               }
  //             }
  // //							sum+=eqMap.numHC * rate;
  //           }
  //         }
  //         if(eqMap.hasOwnProperty("num40"))  //num40
  //         {
  //           if(qf.eq40){
  //             rate=Math.ceil(Number(qf.eq40));
  //             for each(seaEQ in eqMap.num40.pf){
  //               if(seaEQ.EQtype==qf.eqType){
  //                 sum+= seaEQ.EQquantity*rate;
  //               } else {
  //                 isEQAllMatched=false;
  //               }
  //             }
  // //							sum+=eqMap.num40 * rate;
  //           }
  //         }
  //         if(eqMap.hasOwnProperty("num20"))  //num20
  //         {
  //           if(qf.eq20){
  //             rate=Math.ceil(Number(qf.eq20));
  //             for each(seaEQ in eqMap.num20.pf){
  //               if(seaEQ.EQtype==qf.eqType){
  //                 sum+= seaEQ.EQquantity*rate;
  //               } else {
  //                 isEQAllMatched=false;
  //               }
  //             }
  // //							sum+=eqMap.num20 * rate;
  //           }
  //         }
  //         if(sum){
  //           charge = new Charge();
  //           charge.chargeItemId = chargeItem.itemId; //海运费
  //           charge.currency = qf.currency;
  //           charge.measure = ChargeMeasure.NML_CHARGE_MEASURE.code;
  // //						charge.quantity = 1; //数量
  // //						charge.unitRate = sum;
  //           if(isOneContainerType){
  //             charge.quantity = seaEQs[0].EQquantity;
  //             charge.unitRate = rate;
  //           } else {
  //             charge.quantity = 1;
  //             charge.unitRate = sum;
  //           }
  //           charge.taxRate=qf.pf.sellVat;
  //           charge.taxAmount=charge.unitRate *charge.taxRate;
  //           copyDataToCharge(charge,job,isReceivable);
  //           charges.addItemAt(charge,0);
  //         }
  //       }
  //     } else {
  //       messages.push("OF");
  //     }
  //
  //     if(!isEQAllMatched){
  //       if(messages.length>0){
  //         messages=["费用"+messages.join()+"未找到！"];
  //       }
  //       messages.push("部分集装箱没有对应箱型的海运费，请手动添加！");
  //       MessageDialog.warning(messages.join());
  //     } else {
  //       if(messages.length>0){
  //         MessageDialog.warning("费用"+messages.join()+"未找到！");
  //       }
  //     }
  //     return charges;
  //   }
  //
  /**
   * 运价订舱生成(主运费 OF)和附加费
   */
  static async convertPriceChargeToEqType(job, fcl, surcharge) {
    let charges = []
    const message = []
    const ofCharges = await this.generatePriceOFCharge(job, fcl, message)
    const surcharges = await this.generatePriceSurCharge(job, surcharge, message)

    charges = [... ofCharges, ... surcharges]

    if (message.length > 0) {
      Message.warning('费用平台代码【' + message.join() + '】未找到.')
    }
    return charges
  }

  /**
   * 运价订舱生成(主运费 OF, 生成(应收按：T1,one20,one40,oneHC,one45,应付按：cost20,cost40,costhc,cost45)
   * pf:PriceFcl
   */
  static async generatePriceOFCharge(job, pf, message) {
    const charges = []
    const chargeItem = await ChargeItem.getChargeItemByScaleCode(DEFAULT_OF_CHARGE)
    if (chargeItem === null) {
      message.push(DEFAULT_OF_CHARGE)
    } else {
      for (const seaEQ of job.seaEQ) {
        if (seaEQ.eqType === DEFAULT_EQTYPE_GP) {
          if (seaEQ.eqSize === '20') {
            if (pf.one20 !== PriceConstant.NIL && pf.one20 > 0) {
              charges.push(this.createOfCostCharge(job, pf, chargeItem, seaEQ, ChargeMeasure.C20_CHARGE_MEASURE.code, Math.ceil(Number(pf.one20)), false))
            }
            if (pf.cost20 !== PriceConstant.NIL && pf.cost20 > 0) {
              charges.push(this.createOfCostCharge(job, pf, chargeItem, seaEQ, ChargeMeasure.C20_CHARGE_MEASURE.code, Math.ceil(Number(pf.cost20))))
            }
          } else if (seaEQ.eqSize === '40') {
            if (pf.one40 !== PriceConstant.NIL && pf.one40 > 0) {
              charges.push(this.createOfCostCharge(job, pf, chargeItem, seaEQ, ChargeMeasure.C40_CHARGE_MEASURE.code, Math.ceil(Number(pf.one40)), false))
            }
            if (pf.cost40 !== PriceConstant.NIL && pf.cost40 > 0) {
              charges.push(this.createOfCostCharge(job, pf, chargeItem, seaEQ, ChargeMeasure.C40_CHARGE_MEASURE.code, Math.ceil(Number(pf.cost40))))
            }
          } else if (seaEQ.eqSize === '45' && pf.one45 !== PriceConstant.NIL && pf.one45 > 0) {
            if (pf.one45 !== PriceConstant.NIL && pf.one45 > 0) {
              charges.push(this.createOfCostCharge(job, pf, chargeItem, seaEQ, ChargeMeasure.C45_CHARGE_MEASURE.code, Math.ceil(Number(pf.one45)), false))
            }
            if (pf.cost45 !== PriceConstant.NIL && pf.cost45 > 0) {
              charges.push(this.createOfCostCharge(job, pf, chargeItem, seaEQ, ChargeMeasure.C45_CHARGE_MEASURE.code, Math.ceil(Number(pf.cost45))))
            }
          }
        } else if (seaEQ.eqType === DEFAULT_EQTYPE_HC && seaEQ.eqSize === '40') {
          if (pf.oneHC !== PriceConstant.NIL && pf.oneHC > 0) {
            charges.push(this.createOfCostCharge(job, pf, chargeItem, seaEQ, ChargeMeasure.C40H_CHARGE_MEASURE.code, Math.ceil(Number(pf.oneHC)), false))
          }
          if (pf.costhc !== PriceConstant.NIL && pf.costhc > 0) {
            charges.push(this.createOfCostCharge(job, pf, chargeItem, seaEQ, ChargeMeasure.C40H_CHARGE_MEASURE.code, Math.ceil(Number(pf.costhc))))
          }
        }
      }
    }
    return charges
  }

  /**
   * 运价主运费生成(成本和收入) pf:PriceFcl
   */
  static createOfCostCharge(job, pf, chargeItem, seaEQ, measure, unitRate, isCost = true) {
    const charge = new Charge().fillDefaultValue().getData()
    charge.chargeItemId = chargeItem.itemId
    charge.currency = pf.currency
    charge.measure = measure
    charge.quantity = seaEQ.eqQuantity
    charge.unitRate = unitRate
    charge.taxRate = isCost ? pf.costVat : pf.sellVat
    charge.taxAmount = charge.unitRate * charge.taxRate
    this.copyDataToCharge(charge, job, !isCost)
    return charge
  }

  /**
   * 运价订舱生成附加费 (根据业务的箱型箱种去匹配)
   */
  static async generatePriceSurCharge(job, surchargeFcls, message) {
    const surcharges = this.getUnconflictSurcharges(job, surchargeFcls)
    const charges = []
    let charge = null // :Charge = null;
    let chargeItem = null
    // const sf = null:SurchargeFCL = null;
    // 生成单价费用
    await cache.load(cacheName.CONFIG)
    const isInputZeroFee = parseInt(cache.config.get('InputZeroFee')) === 1
    for (const sf of surcharges) {
      if (!sf.generateCharge || sf.casePrice === PriceConstant.NIL) {
        continue
      }

      // 单价和20，40，45，HC不能同时生成
      chargeItem = await ChargeItem.getChargeItemByScaleCode(sf.chargeScaleCode)
      if (chargeItem) {
        // 成本
        if (isInputZeroFee || sf.costCasePrice !== 0) {
          charges.push(this.createSurChargeCasePrice(job, chargeItem, sf))
        }
        if (isInputZeroFee || sf.casePrice !== 0) {
          charges.push(this.createSurChargeCasePrice(job, chargeItem, sf, false))
        }
      } else {
        message.push(sf.chargeScaleCode)
      }
    }
    // 生成匹配项种的费用
    for (const seaEQ of job.seaEQ) {
      for (const sf of surcharges) {
        if (sf.generateCharge && sf.casePrice === PriceConstant.NIL) {
          if (seaEQ.eqType === sf.eqType) {
            if (seaEQ.eqSize === '20') {
              // 成本
              if (sf.cost20 !== PriceConstant.NIL && ((isInputZeroFee && sf.cost20 === 0) || sf.cost20 > 0)) {
                charge = await this.createSurChargeCaseEQType(job, sf, seaEQ, sf.cost20, ChargeMeasure.C20_CHARGE_MEASURE.code)
                if (charge != null) {
                  charges.push(charge)
                } else {
                  message.push(sf.chargeScaleCode)
                }
              }
              // 收入
              if (sf.sum20 !== PriceConstant.NIL && ((isInputZeroFee && sf.sum20 === 0) || sf.sum20 > 0)) {
                charge = await this.createSurChargeCaseEQType(job, sf, seaEQ, sf.sum20, ChargeMeasure.C20_CHARGE_MEASURE.code, false)
                if (charge != null) {
                  charges.push(charge)
                } else {
                  message.push(sf.chargeScaleCode)
                }
              }
            } else if (seaEQ.eqSize === '40') {
              if (sf.cost40 !== PriceConstant.NIL && ((isInputZeroFee && sf.cost40 === 0) || sf.cost40 > 0)) {
                charge = await this.createSurChargeCaseEQType(job, sf, seaEQ, sf.cost40, ChargeMeasure.C40_CHARGE_MEASURE.code)
                if (charge != null) {
                  charges.push(charge)
                } else {
                  message.push(sf.chargeScaleCode)
                }
              }
              if (sf.sum40 !== PriceConstant.NIL && ((isInputZeroFee && sf.sum40 === 0) || sf.sum40 > 0)) {
                charge = await this.createSurChargeCaseEQType(job, sf, seaEQ, sf.sum40, ChargeMeasure.C40_CHARGE_MEASURE.code, false)
                if (charge != null) {
                  charges.push(charge)
                } else {
                  message.push(sf.chargeScaleCode)
                }
              }
            } else if (seaEQ.eqSize === '45') {
              if (sf.cost45 !== PriceConstant.NIL && ((isInputZeroFee && sf.cost45 === 0) || sf.cost45 > 0)) {
                charge = await this.createSurChargeCaseEQType(job, sf, seaEQ, sf.cost45, ChargeMeasure.C45_CHARGE_MEASURE.code)
                if (charge != null) {
                  charges.push(charge)
                } else {
                  message.push(sf.chargeScaleCode)
                }
              }
              if (sf.sum45 !== PriceConstant.NIL && ((isInputZeroFee && sf.sum45 === 0) || sf.sum45 > 0)) {
                charge = await this.createSurChargeCaseEQType(job, sf, seaEQ, sf.sum45, ChargeMeasure.C45_CHARGE_MEASURE.code, false)
                if (charge != null) {
                  charges.push(charge)
                } else {
                  message.push(sf.chargeScaleCode)
                }
              }
            }
          } else if (seaEQ.eqType === DEFAULT_EQTYPE_HC && seaEQ.eqSize === '40') {
            if (sf.costhc !== PriceConstant.NIL && ((isInputZeroFee && sf.costhc === 0) || sf.costhc > 0)) {
              charge = await this.createSurChargeCaseEQType(job, sf, seaEQ, sf.costhc, ChargeMeasure.C40H_CHARGE_MEASURE.code)
              if (charge != null) {
                charges.push(charge)
              } else {
                message.push(sf.chargeScaleCode)
              }
            }
            if (sf.sumhc !== PriceConstant.NIL && ((isInputZeroFee && sf.sumhc === 0) || sf.sumhc > 0)) {
              charge = await this.createSurChargeCaseEQType(job, sf, seaEQ, sf.sumhc, ChargeMeasure.C40H_CHARGE_MEASURE.code, false)
              if (charge != null) {
                charges.push(charge)
              } else {
                message.push(sf.chargeScaleCode)
              }
            }
          }
        }
      }
    }
    return charges
  }

  /**
     * 根据附加费生成应收和应付费用(有单价的)
     * sf:SurchargeFCL
     */
  static createSurChargeCasePrice(job, chargeItem, sf, isCost = true) {
    const charge = new Charge().fillDefaultValue().getData()
    charge.chargeItemId = chargeItem.itemId
    charge.currency = sf.currency
    charge.measure = sf.unit
    charge.quantity = 1
    charge.unitRate = isCost ? sf.costCasePrice : sf.casePrice
    charge.taxRate = isCost ? sf.costVat : sf.sellVat
    charge.taxAmount = charge.unitRate * charge.taxRate
    charge.remarks = sf.remarks
    this.copyDataToCharge(charge, job, !isCost)
    return charge
  }

  /**
   * 根据附加费生成应收和应付费用(箱型、箱种去匹配)
   * sf:SurchargeFCL
   */
  static async createSurChargeCaseEQType(job, sf, seaEQ, unitRate, measure, isCost = true) {
    let charge = null
    const chargeItem = await ChargeItem.getChargeItemByScaleCode(sf.chargeScaleCode)
    if (chargeItem !== null) {
      charge = new Charge().fillDefaultValue().getData()
      charge.chargeItemId = chargeItem.itemId
      charge.currency = sf.currency
      charge.measure = measure
      charge.quantity = seaEQ.eqQuantity
      charge.unitRate = unitRate
      charge.taxRate = sf.costVat
      charge.taxAmount = charge.unitRate * charge.taxRate
      charge.remarks = sf.remarks
      this.copyDataToCharge(charge, job, !isCost)
    }
    return charge
  }

  /**
     * 去掉与ETD不符的附加费
     */
  static getUnconflictSurcharges(job, source) {
    if (source === null || source.length === 0) { return source }
    let isConflict = false
    const map = {}
    let hash
    let arr = []
    for (const surcharge of source) {
      hash = surcharge.chargeType + '_' + surcharge.chargeScaleCode
      if (map.hasOwnProperty(hash)) {
        isConflict = true
        break
      } else {
        map[hash] = true
      }
    }
    if (isConflict) {
      arr = []
      const etd = job.etd
      for (const surcharge of source) {
        if (surcharge.beginDate <= etd && surcharge.endDate >= etd) {
          arr.push(surcharge)
        }
      }
      return arr
    }
    return source
  }

  /**
   * @private
   */
  static async copyDataToCharge(charge, job, isReceivable) {
    // todo charge.job = job;
    if (!job.charges) job.charges = []
    charge.jobUuid = job.uuid
    job.charges.push(charge)
    charge.businessDate = job.businessDate
    charge.accountId = isReceivable ? job.customerId : job.bookingAgent
    charge.receivable = isReceivable
    charge.inputBy = $store.getters.userId
    charge.inputDate = new Date()
    charge.inputByDep = $store.getters.currentDeptId
    charge.branchId = $store.getters.currentOfficeId
    const localCurrency = RateUtil.localCurrencyByOffice()
    charge.localCurrency = localCurrency
    charge.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, charge.currency, job, charge.branchId, function(rate) {
      charge.exchangeRate = rate
    })
    // HQ币种/汇率
    charge.hqCurrency = RateUtil.getHqCurrency(charge.branchId)
    charge.hqRate = await RateUtil.getForeignExchangeRateByJob(charge.hqCurrency, localCurrency, job, charge.branchId)
    ChargeUtils.calculateTax(charge, charge.unitRate * charge.quantity, charge.taxRate)
    charge.verifiedAmount = 0
  }
}
